import React, {useEffect, useRef, useState} from 'react';
import styles from './styles.module.scss';
import Header from './Header';
import List from './List';
import {observer} from 'mobx-react-lite';

import {partsStore} from '../PartsStore';

import {usePartsQuery} from './usePartsQuery';
import {EmptyState} from './EmptyState';
import {sendMonitor} from '../../../utils/monitoring';
import {PARTS_SEARCH_MONITOR, PARTS_SEARCH_MONITOR_SEARCHBUTTON} from '../consts';

type Props = {formName: string; hasTquant: boolean};

const Content = observer(({formName, hasTquant}: Props) => {
    const {
        partsDetails,
        selectedFamilies,
        page,
        setPage,
        showQuantitySelector,
        selectedItems,
        toggleSelectedItems,
        setSetSearchParams,
        searchParams
    } = partsStore;
    const [query, setQuery] = useState('');

    const contianerRef = useRef<HTMLDivElement>();

    const [listFocusedIndex, setListFocusedIndex] = useState(-1);
    const {isLoadingInitialData, isLoadingPageCount, isLoadingPartsDetails} = usePartsQuery(
        formName,
        searchParams
    );
    const scrollbarRef = useRef(null);

    const handleChangeQuery = (value: string) => {
        setQuery(value);
    };

    //on body focus return focus to dialog to enable keyboard events
    useEffect(() => {
        if (document.activeElement.tagName === 'BODY') {
            contianerRef?.current?.focus();
        }
    }, [document.activeElement]);

    useEffect(() => {
        if (!isLoadingPartsDetails) {
            setSetSearchParams({page: page - 1});
        }
    }, [page]);

    const handleSearch = () => {
        setSetSearchParams({page: 0, query});
        setPage(1);
        scrollbarRef?.current?.scrollToTop();
        setListFocusedIndex(0);
        sendMonitor(`${PARTS_SEARCH_MONITOR}${PARTS_SEARCH_MONITOR_SEARCHBUTTON}`);
    };

    useEffect(() => {
        setSetSearchParams({
            selectedFamilies: selectedFamilies || [],
            query,
            page: 0
        });
        setPage(1);
    }, [selectedFamilies]);

    const hasNoResults = !isLoadingInitialData && !isLoadingPartsDetails && !partsDetails?.length;

    return (
        <div ref={contianerRef} tabIndex={0} className={styles.content}>
            <Header
                formName={formName}
                query={query}
                onChangeQuery={handleChangeQuery}
                onSearch={handleSearch}
                hasTquant={hasTquant}
            />
            {!hasNoResults ? (
                <List
                    toggleSelectedItems={toggleSelectedItems}
                    selectedItems={selectedItems}
                    showQuantitySelector={showQuantitySelector}
                    focusedItemIndex={listFocusedIndex}
                    scrollbarRef={scrollbarRef}
                    items={partsDetails}
                    isLoading={isLoadingInitialData || isLoadingPageCount || isLoadingPartsDetails}
                    hasTquant={hasTquant}
                />
            ) : (
                <EmptyState />
            )}
        </div>
    );
});

export default Content;
